import { render } from "./TechnologyDetails.vue?vue&type=template&id=97ed8eb6&scoped=true"
import script from "./TechnologyDetails.vue?vue&type=script&lang=js"
export * from "./TechnologyDetails.vue?vue&type=script&lang=js"

import "./TechnologyDetails.vue?vue&type=style&index=0&id=97ed8eb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97ed8eb6"]])

export default __exports__